import {Country} from "../defs/country";

interface Props {
    country: Country
    visited: boolean
}

function MapCountry({country, visited}: Props) {
    return <path
        d={country.svgPath}
        // title={country.name}
        className={"country country-" + country.countryCode + " " + (visited ? "visited" : "not-visited")}
        id={country.countryCode} />
}

export default MapCountry;
